import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap'
import Api from '../../../../Global/Modules/Api'

class KennisOmzetten extends Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this)
        this.getOmzetten = this.getOmzetten.bind(this)
        this.state = {
            name: '',
            ke: 0,
            overflow: 0
        }
    }
    handleClick(e) {
        e.preventDefault()

        Api.PostApi("api/members/" + this.props.id + "/createoverflow", {}, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    this.setState({ errors: response });
                }
                else {
                    alert("Overflow added")
                    window.location.reload()
                    // TODO: Show message OK
                }
            })
    }

    componentWillMount() {
        this.getOmzetten();
    }
    getOmzetten() {
        var url = "api/members/" + this.props.id + "/overflow";
        Api.GetApi(url).then(data => {
            this.setState({ name: data.name })
            this.setState({ ke: data.ke })
            this.setState({ overflow: data.overflow })
        });
    }
    render() {

        return (
            <div>
                <Row>
                    <Col md={6}>
                        <h5><strong>Kennis omzetten</strong></h5>
                        <Row>
                            <Col md={6} className="companyDataLeft">
                                <p>Naam</p>
                                <p>Punten</p>
                                <p>Overflow</p>
                            </Col>
                            <Col md={6} className="companyDataRight">
                                <p>{this.state.name}</p>
                                <p>{this.state.ke}</p>
                                <p>{this.state.overflow}</p>
                            </Col>
                            <Col md={12}>
                                <br />
                                <Button onClick={this.handleClick}>Kennis omzetten</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}
export default KennisOmzetten;




// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/KennisOmzetten.js